import axios from "axios";
// import * as _ from "lodash";
import { EventBus } from "@/event-bus.js";

export default () => {
  const instance = axios.create({
    baseURL: process.env.VUE_APP_ROOT_API,
    withCredentials: true,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  });

  instance.interceptors.response.use(
    function(response) {
      // Do something with response data
      return response;
    },
    function(error) {
      // Do something with response error
      //if (_.has(error, "response.data.error.message")) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.error.message
      ) {
        EventBus.$emit("error", error.response.data.error.message);
        return Promise.reject(error.response.data.error.message);
      }
      return Promise.reject(error);
    }
  );

  return instance;
};
